//Libs
import { Tooltip } from "antd";
import styled from "styled-components";

const TooltipStyled = styled(Tooltip)``;

export default TooltipStyled;
